import { Box, Button, TextField, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import SimpleBackdrop from "./BackDrop";
import "./settings-modern.css";

function ChangePhone() {
  const [open, setOpen] = React.useState(false);
  const [phone, setPhone] = useState("");
  const [next1, setNext1] = useState(false);
  const [inValidPhone, setInValidPhone] = useState(false);

  const handleSubmit = () => {
    if (!/^05\d{8}$/.test(phone)) return;
    setOpen(true);
    setInValidPhone(false);
    axios.put(
      `${process.env.React_APP_BACKEND_URL}/api/changephone`,
      { phone },
      { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
    ).then(() => {
      setOpen(false);
      setNext1(true);
    }).catch((err) => {
      console.log(err);
      setOpen(false);
      setInValidPhone(true);
    });
  };

  return (
    <Box className="bidit-settings-page-card">
      {!next1 ? (
        <>
          <Box className="bidit-settings-head">
            <Typography className="bidit-settings-title">עדכון מספר טלפון</Typography>
            <Typography className="bidit-settings-subtitle">הזינו מספר נייד ישראלי חדש. המספר משמש לעדכונים ולתקשורת הקשורה לחשבון.</Typography>
          </Box>
          <Typography className="bidit-settings-field-label">מספר טלפון חדש</Typography>
          <TextField
            required
            fullWidth
            value={phone}
            onChange={(e) => setPhone(e.currentTarget.value.replace(/\D/g, "").slice(0, 10))}
            id="phone"
            name="phone"
            type="tel"
            placeholder="05XXXXXXXX"
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10 }}
            autoComplete="tel"
          />
          {inValidPhone && <Box className="bidit-settings-error">לא ניתן לעדכן למספר הזה. ייתכן שהוא כבר קיים במערכת.</Box>}
          <Button fullWidth onClick={handleSubmit} disabled={!/^05\d{8}$/.test(phone)} variant="contained" className="bidit-settings-primary" sx={{ mt: 2.5 }}>
            עדכון מספר הטלפון
          </Button>
        </>
      ) : (
        <Box className="bidit-settings-success">
          <Typography className="bidit-settings-title">מספר הטלפון עודכן בהצלחה</Typography>
          <Button component={NavLink} to="/" variant="contained" className="bidit-settings-primary" sx={{ mt: 2.5 }}>חזרה למסך הבית</Button>
        </Box>
      )}
      {open && <SimpleBackdrop open={open} setOpen={setOpen} handleClose={() => setOpen(false)} handleToogle={() => setOpen(!open)} />}
    </Box>
  );
}
export default ChangePhone;
